/**
 * The bodies the server stores in place of words nobody wrote, and the raw
 * types whose content lands after the row that announces it.
 *
 * They live in ONE module because the whole mechanism rests on matching them
 * EXACTLY — in the manager's console (`ConversationPanel`) and on the
 * resident's page (`ResidentConversationPage`) alike. A stored sentinel is the
 * server's marker, not somebody's sentence: a surface recognises it and prints
 * its own wording in the reader's language instead, and never shows the
 * sentinel itself. Copying the literals into a second component is exactly how
 * one of the two drifts and starts showing French machine prose to a reader.
 */

/**
 * `conversations.VoicePlaceholderBody` — a recording whose transcript has not
 * landed (or never will).
 */
export const VOICE_PLACEHOLDER_BODY = '(note vocale sans transcription)'

/**
 * `conversations.MediaPendingBody` — an inbound media message with no caption
 * whose bytes are still on their way.
 */
export const MEDIA_PENDING_BODY = '(pièce jointe en cours de récupération…)'

/**
 * `conversations.MediaFailedBody` — the fetch failed definitively. The reason
 * itself travels in `dropped_attachments`, which only the console reads.
 */
export const MEDIA_FAILED_BODY = '(pièce jointe non récupérée)'

/** Every stored media sentinel, for the "is this the server talking?" test. */
export const MEDIA_PLACEHOLDER_BODIES = new Set<string>([MEDIA_PENDING_BODY, MEDIA_FAILED_BODY])

/**
 * The raw types that carry content the server fetches separately (spec
 * 2026-09-09-12).
 *
 * A WhatsApp photo, voice note, video, sticker or document arrives as a media
 * id: the message is stored at once and its bytes land afterwards, through the
 * `whatsapp_media_fetch` job. While they are on their way the message has no
 * attachment — which is how a surface recognises the pending state, rather
 * than by matching a stored sentence.
 */
export const MEDIA_RAW_TYPES = new Set<string>(['image', 'audio', 'video', 'document'])
